import { render, staticRenderFns } from "./generateStatement.vue?vue&type=template&id=3ac54977&scoped=true&"
import script from "./generateStatement.vue?vue&type=script&lang=js&"
export * from "./generateStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac54977",
  null
  
)

export default component.exports